// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pens-content{
    background: #F5F0F5;
    padding: 0 10px 10px 10px;
}
.pens-window.active {
    display: block;
}

.pens-table {
    border-collapse: collapse;
    font-size: 12px;
}

.pen-table-color {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    border-radius: 4px;
    height: 20px;
    background-color: transparent;
}


    .pen-table-color::-webkit-color-swatch {
        border: none;
    }

.table-head {
    border-bottom: 1px solid;
    background: #F5F0F5;
}

.pens-table tr th {
    border-left: 1px solid;
    border-right: 1px solid;
    white-space: nowrap;
    padding: 5px 20px;
    font-weight: normal;
}

.pens-table tr th,
.pens-table tr td {
    text-align: center;
}

.pens-table tr td {
    padding: 5px;
}
.pens-table tr td input{
    width: fit-content;
}

    .pens-table tr td:nth-child(2) {
        padding: 5px 10px;
    }

.select-pen {
    display: inline-block;
    color: #1E90FF;
    font-size: 12px;
    font-style: italic;
    cursor: pointer;
    padding: 3px 8px;
    text-decoration: underline;
}

.pointer {
    font-size: 12px;
    padding: 1px 5px;
}

.pens-buttons-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 10px;
}

.pens-btn {
    cursor: pointer;
    color: #fff;
    padding: 4px 14px;
    background: #4D6EAF;
    border-radius: 4px;
    font-size: 12px;
    line-height: 17px;
}
`, "",{"version":3,"sources":["webpack://./src/controls/chartcolumn/popups/pens/pens.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;;IAGI;QACI,YAAY;IAChB;;AAEJ;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".pens-content{\r\n    background: #F5F0F5;\r\n    padding: 0 10px 10px 10px;\r\n}\r\n.pens-window.active {\r\n    display: block;\r\n}\r\n\r\n.pens-table {\r\n    border-collapse: collapse;\r\n    font-size: 12px;\r\n}\r\n\r\n.pen-table-color {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    border: none;\r\n    border-radius: 4px;\r\n    height: 20px;\r\n    background-color: transparent;\r\n}\r\n\r\n\r\n    .pen-table-color::-webkit-color-swatch {\r\n        border: none;\r\n    }\r\n\r\n.table-head {\r\n    border-bottom: 1px solid;\r\n    background: #F5F0F5;\r\n}\r\n\r\n.pens-table tr th {\r\n    border-left: 1px solid;\r\n    border-right: 1px solid;\r\n    white-space: nowrap;\r\n    padding: 5px 20px;\r\n    font-weight: normal;\r\n}\r\n\r\n.pens-table tr th,\r\n.pens-table tr td {\r\n    text-align: center;\r\n}\r\n\r\n.pens-table tr td {\r\n    padding: 5px;\r\n}\r\n.pens-table tr td input{\r\n    width: fit-content;\r\n}\r\n\r\n    .pens-table tr td:nth-child(2) {\r\n        padding: 5px 10px;\r\n    }\r\n\r\n.select-pen {\r\n    display: inline-block;\r\n    color: #1E90FF;\r\n    font-size: 12px;\r\n    font-style: italic;\r\n    cursor: pointer;\r\n    padding: 3px 8px;\r\n    text-decoration: underline;\r\n}\r\n\r\n.pointer {\r\n    font-size: 12px;\r\n    padding: 1px 5px;\r\n}\r\n\r\n.pens-buttons-wrap {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 20px;\r\n    padding-top: 10px;\r\n}\r\n\r\n.pens-btn {\r\n    cursor: pointer;\r\n    color: #fff;\r\n    padding: 4px 14px;\r\n    background: #4D6EAF;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    line-height: 17px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
